import React from 'react';
import { useSelector } from 'react-redux';
import Logo from '../../assets/images/logo-master-white.png';

function AgencyLogo({ logo }) {
  const { org } = useSelector(({ auth }) => auth);

  if (logo) {
    return <img style={{ width: '200px' }} src={logo} alt={org?.name} />;
  }

  return (
    <img
      style={{ height: 'auto', width: '140px' }}
      className={org.logo ? 'biglogo' : ''}
      src={org?.logo ? org?.logo : Logo}
      alt={org?.name}
    />
  );
}

export default AgencyLogo;
